import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import connect from 'app/libs/connect';
import S from 'app/features/newLanding/components/newProductComparison/Product/Title.styled';
import Text from 'app/components/layout/Text.styled';
import { productTitleKey } from 'app/features/products/selectors';

const UI = ({ textKey }) => (
  <Text as={S.Title} size="xl" data-t="product-comparison-subscription-heading">
    <FormattedMessage id={textKey} />
  </Text>
);

UI.propTypes = {
  textKey: PropTypes.string.isRequired,
};

UI.displayName = 'Title';

const Title = connect({ textKey: productTitleKey })(UI);

export { UI };

export default Title;
